/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/IPlayCardDailyAuthority',[],function() {
    var IPlayCardDailyAuthority = function () {
        this.NumberPlayed = 0;
        this.SuppressClearHintsOnMouseDown = true;
    };

    return IPlayCardDailyAuthority;
});
